import { Injectable } from "@angular/core";
@Injectable()
export class StringService {
    htmlEncode(value: string) {
        return value.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
            return '&#' + i.charCodeAt(0) + ';';
        });
    }

    htmlDecode(value: string) {
        return new DOMParser().parseFromString(value, 'text/html').body.textContent;
    }
}
